import React, { useState, useEffect } from "react";
import { Typography, Grid, Checkbox, FormControl, Select, MenuItem } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import useStyles from "../styles";
import MLocation from "../../Profile/Modal/MLocation";
import Images from "../../../Config/Images";
import { isEmpty } from "lodash";
import { relocationCountries } from "../../../Config/Static_Data";

function JobLocation(props) {
  const { setData = () => null, data = {} } = props;
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);

  const [editData, setEditData] = useState({});
  const isComplete = !isEmpty(editData);
  const isDataEmpty = !isEmpty(data);
  const [relocationRequired, setRelocationRequired] = useState(false);
  const [selectedRelocationCountry, setSelectedRelocationCountry] = useState(null);

  useEffect(() => {
    if (isDataEmpty) {
      setEditData(
        {
          selectedLocation: {
            location: data?.location,
            lat: data?.lat,
            lng: data?.long,
          },
          remoteOnly: data?.is_remote === 1 ? true : false,
        } || {}
      );
      setRelocationRequired(data?.relocation_required === 1 ? true : false);
      // Handle single country string from DB
      if (data?.relocation_countries) {
        const countryObj = relocationCountries.find(c => c.label === data.relocation_countries);
        setSelectedRelocationCountry(countryObj || null);
      } else {
        setSelectedRelocationCountry(null);
      }
    }
  }, [data]);

  useEffect(() => {
    setData({
      ...editData,
      relocationRequired: relocationRequired ? 1 : 0,
      relocationCountries: relocationRequired && selectedRelocationCountry ? selectedRelocationCountry.label : null,
    });
  }, [editData, relocationRequired, selectedRelocationCountry]);

  return (
    <Grid
      item
      xs={12}
      className={[
        classes.shadowViewStyle,
        classes.paddingStyle,
        classes.marginDiv,
      ]}
    >
      <div id="joblocation" className={classes.splitViewStyle}>
        <Typography className={classes.sectionTitle}>Job Location*</Typography>
        {isComplete ? (
          <div
            className={classes.editBtnStyle}
            onClick={() => setOpenModal(true)}
          >
            <img src={Images.edit} style={{ width: 14 }} />
          </div>
        ) : (
          <AddCircle
            className={classes.addIcon}
            onClick={() => {
              setOpenModal(true);
            }}
          />
        )}
      </div>
      {isComplete ? (
        <div style={{ marginTop: 10 }}>
          {editData?.remoteOnly ? (
            <Typography className="regulerfont primarycolor">
              You have selected candidates from all locations within the United
              Arab Emirates
            </Typography>
          ) : (
            <Typography className="regulerfont primarycolor">
              Location: {editData?.selectedLocation?.location}
            </Typography>
          )}
        </div>
      ) : (
        <Typography className={classes.sectionDesc}>Add location</Typography>
      )}

      <MLocation
        visible={openModal}
        handleModal={() => {
          setOpenModal(false);
        }}
        onSave={(data) => {
          setEditData(data);
          setOpenModal(false);
        }}
        editData={editData}
      />

      {/* Relocation Section */}
      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Typography className={classes.sectionTitle} style={{ marginBottom: 10 }}>
          Relocation Options
        </Typography>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
          <Checkbox
            checked={relocationRequired}
            onChange={() => {
              setRelocationRequired(!relocationRequired);
              if (!relocationRequired) setSelectedRelocationCountry(null);
            }}
            style={{ padding: 0, marginRight: 8 }}
          />
          <Typography className="regulerfont">
            Open to candidates willing to relocate
          </Typography>
        </div>
        {relocationRequired && (
          <div style={{ marginTop: 10 }}>
            <Typography className="regulerfont" style={{ marginBottom: 8 }}>
              Select country open for relocation
            </Typography>
            <FormControl fullWidth variant="outlined" size="small">
              <Select
                displayEmpty
                value={selectedRelocationCountry?.label || ""}
                onChange={(e) => {
                  const countryObj = relocationCountries.find(c => c.label === e.target.value);
                  setSelectedRelocationCountry(countryObj || null);
                }}
                style={{ minHeight: 40 }}
              >
                {relocationCountries.map((country) => (
                  <MenuItem key={country.value} value={country.label}>
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
      </Grid>
    </Grid>
  );
}

export default JobLocation;
